import React, { createContext, useState, ReactNode, useContext } from 'react'
import ContactForm from '../ContactForm'

interface ContactFormContextProps {
  showContactForm: boolean
  setShowContactForm: React.Dispatch<React.SetStateAction<boolean>>
}

export const ContactFormContext = createContext<ContactFormContextProps>({
  showContactForm: false,
  setShowContactForm: () => {}
})

interface ContactFormProviderProps {
  children: ReactNode
}

export const ContactFormProvider: React.FC<ContactFormProviderProps> = ({
  children
}) => {
  const [showContactForm, setShowContactForm] = useState<boolean>(false)

  return (
    <ContactFormContext.Provider
      value={{ showContactForm, setShowContactForm }}
    >
      {children}
    </ContactFormContext.Provider>
  )
}

export const ContactFormContainer: React.FC = () => {
  const { showContactForm, setShowContactForm } = useContext(ContactFormContext)
  return (
    <ContactForm
      show={showContactForm}
      onClose={() => setShowContactForm(false)}
    />
  )
}

export const useContactForm = () => {
  const { showContactForm, setShowContactForm } = useContext(ContactFormContext)
  return { showContactForm, setShowContactForm }
}
